const zh = {
  i18nView: {
    login: '登录',
    account: '账号',
    currentAccount: '当前账号',
    balance: '余额',
    logout: '登出',
    contract: '合约',
    used: '已用',
    rent: '资源租借',
    contractRamTip: '如合约的内存不足，没有该币的新用户无法进行挖矿',
    ram: '内存',
    digTip: '当前挖一次预计得 ',
    whiteTip: '开启后请添加白名单（高级设置）',
    airgrabTip: '根据 EIDOS 的空投方式，用户可以将任意金额的 EOS 转账至 eidosonecoin 这个账户，智能合约会将等量的 EOS 返回至用户账户，并会将 eidosonecoin 这个账户中存有的 0.01% EIDOS 发送到用户账户中',
    enableAuto: '开启自动转账',
    stopAuto: '停止自动转账',
    eidosTitle: '空投矿机',
    error: '错误: ',
    trade: '去交易',
    fastMode: '超速模式',
    digTime: '挖矿次数',
    changeNode: '修改节点',
    diggingSetting: '每挖一次预计超过',
    diggingSetting1: '执行挖矿',
    cpuTips: 'CPU & NET超过100%挖矿将会失败',
    settingTips: '链上操作有时间差,以及可用cpu波动较大,效果会有误差',
    advSetting: '高级设置',
    cpuQuota: 'CPU使用上限',
    cpuQuotaTip: '(超出该百分比后停止挖矿，默认0为不限制)',
    notEnough: '不足 ',
    left: '剩余 ',
    actionsPerTx: '倍速:',
    actionsPerTxTip: '倍速越高挖矿速度越快',
    bpBlocker: '智能模式',
    bpBlockerTip: '黑科技提高CPU使用效率约20%，非常依赖用户当前网络环境和已选节点的速度，挖矿速度非常缓慢',
    fastModeTip: '请提前设置好白名单，目前与智能模式不能同时开启，挖矿速度超快',
    randomNode: '随机切换',
    startTransfer: '开始挖矿...',
    success: '成功!',
    failed: '失败! 如失败次数较多请尝试切换节点',
    nodeChanged: '节点已切换',
    noMatch: '已取消本次，不符合设定的条件',
    cpuNotEnough: 'CPU 不足!',
    swapYas: 'YAS映射',
    miningTips: '矿机使用人数较多，导致大部分节点不稳定，如始终无法正常挖矿，可以尝试TP钱包内的其他矿机'
  }
};

export default zh;